import { CustomerApplication } from '../customer-application';
import { SharedDataService } from '../shared/shared-data/shared-data.service';
import { RestAPIService } from '../shared/shared-service/restAPI.service';
import { Component, OnInit } from '@angular/core';
import { Location, DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { UpdateApplication } from './update-application';
import { BypassAuthGroupInfo } from '../../app/register-application/bypass-auth-group-info';
import { BypassAuthIpEmailInfo } from '../../app/register-application/bypass-auth-ip-email-info';
import swal from 'sweetalert2';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss']
})
export class DetailsComponent implements OnInit {
  application: CustomerApplication;
  validationMessages: any;
  portalConfigValuesFromS3: any;
  edit: boolean = true;
  apiKey: string;
  updateApp: UpdateApplication = new UpdateApplication();
  successApiUrlTitle: string;
  failureApiUrlTitle: string;
  cyberscoreThresholdTitle: string;
  allowBypassOsTitle: string;
  allowFailureTitle: string;
  numberAttemptsAllowedTitle: string;
  timePeriodTitle: string;
  apiKeyTitle: string;
  datetime: any;
  date: string;
  time: string;
  isFailureAllow: boolean;
  numberAttemptsAllowed: number;
  timePeriod: number;
  byPassAppletCheck: boolean;
  byPassValueSetGroup1: number[];
  byPassValueGroup1: number;
  byPassValueSetGroup2: number[];
  byPassValueGroup2: number;
  byPassValueSetGroup3: number[];
  byPassValueGroup3: number;
  group4DaysValue: number;
  gracePeriodApplyToAllUsersCheck = false;
  group4InfoText: string;
  isGroup4Edited: boolean = false;
  numberofDaysRemainingGroup4: string;
  emailValueGroup1: string;
  emailValueGroup2: string;
  emailValueGroup3: string;
  ipAddressGroup: string;
  emailbyPassGroup: string;
  numberofDaysRemainingGroup1: string;
  numberofDaysRemainingGroup2: string;
  numberofDaysRemainingGroup3: string;

  showOsByPass: boolean;
  allowLoginGracePeriod: string;
  allowBypassIpaddressTitle: string;
  enableRemediationTitle: string;
  skipAppletCheckAfterInstallingTitle: string;
  enableRemediation: boolean;
  skipAppletCheckAfterInstalling: boolean;
  bypassAuthGroupInfo: BypassAuthGroupInfo = new BypassAuthGroupInfo();
  bypassAuthIpEmailInfo: BypassAuthIpEmailInfo = null;
  isValidForm: boolean = true;
  isValidCyberscore: boolean = true;
  isValidFailureTime: boolean = true;
  isValidFailedAttempts: boolean = true;
  applicationCopy: CustomerApplication;
  startDateOfByPassAgentActivation: any;
  noOfDaysByPassAgentActivation: any;
  enablePhishing: boolean;
  enableSAT: boolean;
  thirdPartyServiceString: string;
  satCompulsaryToLoginInstr: string = "";
  enableHelpTitle: string;
  enableHelp: boolean;
  isValidHelpAttempt = true;
  helpAttemptsAllowedTitle: string;
  maxHelpButtonAttemptsAllowed: number;

  constructor(private router: Router, private restAPIService: RestAPIService,
    private location: Location, private sharedDataService: SharedDataService, private datePipe: DatePipe) {
    this.successApiUrlTitle = 'User is redirected to this URL if validation is successful. Typically, this is your application’s main page';
    this.failureApiUrlTitle = 'User is redirected to this URL if validation is not successful. Typically, this will force user to get logged out of your application.';
    this.cyberscoreThresholdTitle = 'Access is allowed only if the Unify cyberscore of user’s device is above this threshold.';
    this.allowBypassOsTitle = 'The Entreda Unify Authentication service is not supported in older operating systems (this includes Mac OS 10.9.x and 10.10.x). For these devices, do you want to bypass the authentication validation and allow such devices to login?';
    this.apiKeyTitle = 'Unique API key generated for your application and will be used in your API call.';
    this.allowFailureTitle = 'Allow users to login to application if device does not meet cyberscore threshold for a number of attempts, over a fixed time period.  Upon expiration of the time period, the number of attempts where device does not meet cyberscore requirements, resets back to zero.';
    this.numberAttemptsAllowedTitle = 'Number of attempts a user can login without addressing cyberscore threshold requirements.';
    this.timePeriodTitle = 'Time period before number of attempts to login allowed resets back to zero.';
    this.enableRemediationTitle = 'Allow remediate failed items.';
    this.skipAppletCheckAfterInstallingTitle = 'Skip applet check after installation.';
    this.group4InfoText = 'If enabled, this will apply a Grace Period for installing the Enteda Application for all users under this registered Web Application';

    this.enablePhishing = false;
    this.enableSAT = false;
    this.thirdPartyServiceString = "Additional user related services you want to integrate";

    this.application = this.sharedDataService.getCustomerApplication();
    this.helpAttemptsAllowedTitle = 'If a user leverages the Help option this many \ntimes without raising their Cyberscore above \nthe threshold, the Help option will be disabled \nfor that User.';
    if(this.application.maxHelpButtonAttempt === undefined){
       this.application.maxHelpButtonAttempt = 0;
    }
    this.applicationCopy = JSON.parse(JSON.stringify(this.application));
    this.validationMessages = this.sharedDataService.getValidationMessages();
    this.portalConfigValuesFromS3 = this.sharedDataService.getPortalConfigValuesFromS3();
    this.setData()
  }

  checkGroup4UpdatedDays() {
      // this.bypassAuthGroupInfo.group4Days
      if (
        this.byPassAppletCheck &&
        this.gracePeriodApplyToAllUsersCheck &&
        this.bypassAuthGroupInfo.group4Days !== this.group4DaysValue
      ) {
        swal({
          title: 'Are you sure?',
          text: 'This will reset the grace period for all users to ' + this.group4DaysValue + ' days from today',
          type: 'warning',
          showConfirmButton: true,
          showCancelButton: true
        })
        .then((willUpdate) => {}) .catch(() => {
          this.group4DaysValue = this.bypassAuthGroupInfo.group4Days;
          swal.noop();
        });
      }
    }

      validateGroupDays(allowGracePeriod: boolean) {
        if (allowGracePeriod) {
          this.validateGroup4Days();
          this.byPassValueGroup1 = this.byPassValueSetGroup1[0];
          this.byPassValueGroup2 = this.byPassValueSetGroup2[0];
          this.byPassValueGroup3 = this.byPassValueSetGroup3[0];
        } else {
          this.gracePeriodApplyToAllUsersCheck = false;
          this.isValidForm = true;
          $('#group4DaysRequiredDiv').hide();
        }
      }

      validateGroup4Days() {
        if (this.byPassAppletCheck) {
        if (
          this.gracePeriodApplyToAllUsersCheck &&
          (this.group4DaysValue === undefined || this.group4DaysValue === null)
        ) {
          this.isValidForm = false;
          $('#group4DaysRequiredDiv').show();
        } else {
          this.isValidForm = true;
          $('#group4DaysRequiredDiv').hide();
        }
      }else {
        this.isValidForm = true;
          $('#group4DaysRequiredDiv').hide();
      }
   }

  validateMaxFailedRetriesAttempts() {
    if (this.isFailureAllow && this.application.maxFailedRetriesAttempts !== null && (this.application.maxFailedRetriesAttempts > Number(this.portalConfigValuesFromS3.MAX_RETRIES_FAILED_PERIOD_AND_MAX_FAILED_RETRIES_ATTEMPTS) || this.application.maxFailedRetriesAttempts < Number(this.portalConfigValuesFromS3.MIN_RETRIES_FAILED_PERIOD_AND_MAX_FAILED_RETRIES_ATTEMPTS))) {
      $("#maxFailedRetriesAttemptsRangeErrorDiv").show();
      this.isValidForm = false;
      this.isValidFailedAttempts = false;
    } else {
      $("#maxFailedRetriesAttemptsRangeErrorDiv").hide();
      this.isValidFailedAttempts = true;
      if (this.isValidCyberscore && this.isValidFailureTime) {
        this.isValidForm = true;
      }
    }
  }

  validateRetriesFailedPeriod() {
    if (this.isFailureAllow && this.application.retriesFailedPeriod !== null && (this.application.retriesFailedPeriod > Number(this.portalConfigValuesFromS3.MAX_RETRIES_FAILED_PERIOD_AND_MAX_FAILED_RETRIES_ATTEMPTS) || this.application.retriesFailedPeriod < Number(this.portalConfigValuesFromS3.MIN_RETRIES_FAILED_PERIOD_AND_MAX_FAILED_RETRIES_ATTEMPTS))) {
      $("#retriesFailedPeriodRangeErrorDiv").show();
      this.isValidForm = false;
      this.isValidFailureTime = false;
    } else {
      $("#retriesFailedPeriodRangeErrorDiv").hide();
      this.isValidFailureTime = true;
      if (this.isValidCyberscore && this.isValidFailedAttempts) {
        this.isValidForm = true;
      }
    }
  }

  validateCyberscoreThresholdRange() {
    if (this.application.cyberScoreThreshold !== null && (this.application.cyberScoreThreshold > 800 || this.application.cyberScoreThreshold < 1)) {
      $("#cyberScoreThresholdRangeErrorDiv").show();
      this.isValidForm = false;
      this.isValidCyberscore = false;
    } else {
      $("#cyberScoreThresholdRangeErrorDiv").hide();
      this.isValidCyberscore = true;
      if (this.isValidFailureTime && this.isValidFailedAttempts) {
        this.isValidForm = true;
      }
    }
  }

  ngOnInit() {
  }
  goBack(): void {
    this.location.back();
  }

  numberofDaysRemainig(numberdaysGroup: number): number {
    let CurrentDate = new Date();
    let applicationDateTime = new Date(this.application.appletByPassDateTime);
    let expireationDateGroup1 = applicationDateTime.setUTCDate(applicationDateTime.getUTCDate() + numberdaysGroup);
    let timeDiff = expireationDateGroup1 - CurrentDate.getTime();
    return Math.ceil(timeDiff / (1000 * 3600 * 24));
  }

  update(): void {
    this.edit = false;
  }
  cancel(): void {
    this.application = JSON.parse(JSON.stringify(this.applicationCopy));

    $("#retriesFailedPeriodRangeErrorDiv").hide();
    $("#maxFailedRetriesAttemptsRangeErrorDiv").hide();
    $("#cyberScoreThresholdRangeErrorDiv").hide();
    this.setData();
  }
  updateApplication(): void {
    this.updateApp.isHelpEnabled = this.enableHelp;
    console.log("gracePeriodApplyToAllUsers : "+this.gracePeriodApplyToAllUsersCheck);
    this.updateApp.enableRemediation = this.enableRemediation;
    this.updateApp.skipAppletCheckAfterInstalling = this.skipAppletCheckAfterInstalling;
    this.updateApp.apiKey = this.application.apiKey;
    this.updateApp.cyberScoreThreshold = this.application.cyberScoreThreshold;
    this.updateApp.failureUrl = this.application.failureUrl;
    this.updateApp.successUrl = this.application.successUrl;
    this.updateApp.bypassAuthentication = this.application.bypassAuthentication;

    if (this.isFailureAllow) {
      this.updateApp.maxFailedRetriesAttempts = this.application.maxFailedRetriesAttempts;
      this.updateApp.retriesFailedPeriod = this.application.retriesFailedPeriod;
    } else {
      this.updateApp.maxFailedRetriesAttempts = 0;
      this.updateApp.retriesFailedPeriod = 0;
    }
    if(this.enableHelp){
      this.updateApp.maxHelpButtonAttemptsAllowed = this.application.maxHelpButtonAttempt;
    } else {
      this.updateApp.maxHelpButtonAttemptsAllowed = 0;
    }
    this.updateApp.byPassAppletCheck = this.byPassAppletCheck;
    if (this.application.appletVerificationByPass && this.application.appletByPassDateTime == 0) {
      //If this is the case, then treat this as the first time the customer is opting for the Applet by pass feature
      this.updateApp.updateTimeStamp = true;
    }
    else {
      this.updateApp.updateTimeStamp = false; //else don't update the time stamp and this will help in tracking the date, time the application got created
    }
    this.updateApp.gracePeriodApplyToAllUsers = this.gracePeriodApplyToAllUsersCheck;
    if (this.byPassAppletCheck) {

      this.bypassAuthGroupInfo.group1Days = this.byPassValueGroup1;
      this.bypassAuthGroupInfo.group2Days = this.byPassValueGroup2;
      this.bypassAuthGroupInfo.group3Days = this.byPassValueGroup3;
      this.bypassAuthGroupInfo.group4Days = this.group4DaysValue;

      this.bypassAuthGroupInfo.group1Emails = this.emailValueGroup1;
      this.bypassAuthGroupInfo.group2Emails = this.emailValueGroup2;
      this.bypassAuthGroupInfo.group3Emails = this.emailValueGroup3;

      this.updateApp.byPassApplettGroups = JSON.stringify(
        this.bypassAuthGroupInfo
      );
      this.updateApp.gracePeriodApplyToAllUsers = this.gracePeriodApplyToAllUsersCheck;
    } else {
      this.updateApp.byPassApplettGroups = '{}';
    }

    this.updateApp.appletcheckByPassIpaddress = this.application.appletcheckByPassIpaddress;
    if (this.updateApp.appletcheckByPassIpaddress) {

      this.bypassAuthIpEmailInfo = new BypassAuthIpEmailInfo();
      this.bypassAuthIpEmailInfo.emailList = this.emailbyPassGroup;
      this.bypassAuthIpEmailInfo.ipAddressList = this.ipAddressGroup;

      this.updateApp.appletCheckByPassIpaddressList = JSON.stringify(this.bypassAuthIpEmailInfo);

    }
    else {
      this.updateApp.appletCheckByPassIpaddressList = "{}";
    }

    let finalThirdPartyStr = "";
    if (this.enablePhishing && this.enableSAT) {
      finalThirdPartyStr += "Phishing".concat(",").concat("SAT");
    }
    else if (this.enablePhishing) {
      finalThirdPartyStr = "Phishing";
    }
    else if (this.enableSAT) {
      finalThirdPartyStr = "SAT";
    }
    this.updateApp.thirdPartyServicesActivated = finalThirdPartyStr;
    this.restAPIService.updateApplication(this.updateApp, this.application.id)
      .then(application => {
        this.router.navigate(['/app']);
      }).catch(error => {
        this.sharedDataService.showError(error.message);
      });
  }
  regenerateApiKey(): void {
    this.restAPIService.regenerateApiKey().then(customerApplication => {
      this.application.apiKey = customerApplication.apiKey;
    }).catch(error => {
      this.sharedDataService.showError(error.message);
    });
  }

  resetData(): void {
    this.isFailureAllow = true;
    this.application.maxFailedRetriesAttempts = this.numberAttemptsAllowed;
    this.application.retriesFailedPeriod = this.timePeriod;
    this.validateMaxFailedRetriesAttempts();
    this.validateRetriesFailedPeriod();
  }

  clearData(): void {
    this.isFailureAllow = false;
    this.application.maxFailedRetriesAttempts = 0;
    this.application.retriesFailedPeriod = 0;
    $("#retriesFailedPeriodRangeErrorDiv").hide();
    $("#maxFailedRetriesAttemptsRangeErrorDiv").hide();
    this.isValidFailedAttempts = true;
    this.isValidFailureTime = true;
    if (this.isValidCyberscore) {
      this.isValidForm = true;
    }
  }

  validateMaxHelpAttempts(){
      if (this.enableHelp &&
        this.application.maxHelpButtonAttempt !== null &&
        (this.application.maxHelpButtonAttempt > 999 ||
          this.application.maxHelpButtonAttempt < 1)) {
        $('#maxHelpButtonAttemptRangeErrorDiv').show();
        this.isValidForm = false;
        this.isValidFailedAttempts = false;
      } else {
        $('#maxHelpButtonAttemptRangeErrorDiv').hide();
        this.isValidForm = true;
        this.isValidFailedAttempts = true;
      }
    }

    resetHelpButtonData(): void {
      this.enableHelp = true;
      this.application.maxHelpButtonAttempt = this.maxHelpButtonAttemptsAllowed;
      this.validateMaxHelpAttempts();
    }

    clearHelpButtonData(): void {
      this.enableHelp = false;
      this.application.maxHelpButtonAttempt = 0;
      this.maxHelpButtonAttemptsAllowed = 0;
      $('#maxHelpButtonAttemptRangeErrorDiv').hide();
      this.isValidFailedAttempts = true;
      if (this.isValidCyberscore) {
        this.isValidForm = true;
      }
    }

  setData(): void {
    this.edit = true;
    this.showOsByPass = false;

    if (0 === this.application.maxFailedRetriesAttempts) {
      this.isFailureAllow = false;
    } else {
      this.isFailureAllow = true;
    }
    this.enableRemediation = this.application.enableRemediation;
    this.skipAppletCheckAfterInstalling = this.application.skipAppletCheckAfterInstalling;
    this.numberAttemptsAllowed = this.application.maxFailedRetriesAttempts;
    this.timePeriod = this.application.retriesFailedPeriod;
    this.datetime = this.application.createdTS.split(' ');
    this.date = this.datetime[0];
    this.date = this.datePipe.transform(this.datetime[0], 'MM/dd/yyyy');
    this.time = this.datetime[1];
    this.apiKey = this.application.apiKey;
    this.enableHelp = this.application.isHelpEnabled;
    this.maxHelpButtonAttemptsAllowed = this.application.maxHelpButtonAttempt;
    this.getThirdPartyString();
    this.byPassAppletCheck = this.application.appletVerificationByPass;
    this.byPassValueSetGroup1 = [1, 2, 3, 4, 5, 15, 45, 60, 90];  //1 to 50
    this.byPassValueGroup1 = this.byPassValueSetGroup1[0];
    this.gracePeriodApplyToAllUsersCheck = this.application.gracePeriodApplyToAllUsers;

    this.byPassValueSetGroup2 = [120, 150, 180, 210];  //51 to 80
    this.byPassValueGroup2 = this.byPassValueSetGroup2[0];
    this.byPassValueSetGroup3 = [240, 270, 300, 365];  // Reamining values, untill 365 days
    this.byPassValueGroup3 = this.byPassValueSetGroup3[0];

    try {

      let byPassAppList = JSON.parse(this.application.appletCheckByPassIpaddressList);
      if (byPassAppList.ipAddressList !== undefined) {
        this.ipAddressGroup = byPassAppList.ipAddressList;
      }

      if (byPassAppList.emailList !== undefined) {
        this.emailbyPassGroup = byPassAppList.emailList;
      }

      this.bypassAuthGroupInfo = JSON.parse(this.application.appletVerificationByPassGroups);
      this.gracePeriodApplyToAllUsersCheck = this.application.gracePeriodApplyToAllUsers;
      this.byPassValueGroup1 = this.bypassAuthGroupInfo.group1Days;
      this.byPassValueGroup2 = this.bypassAuthGroupInfo.group2Days;
      this.byPassValueGroup3 = this.bypassAuthGroupInfo.group3Days;
      this.group4DaysValue = this.bypassAuthGroupInfo.group4Days;

      if (this.byPassAppletCheck != undefined && this.byPassAppletCheck != null && this.byPassAppletCheck) {
        if (this.bypassAuthGroupInfo.group1Emails != undefined || this.bypassAuthGroupInfo.group1Emails !== '') {
          let remainingDaysGroup1: number = this.numberofDaysRemainig(this.byPassValueGroup1);
          this.numberofDaysRemainingGroup1 = remainingDaysGroup1 > 0 ? +remainingDaysGroup1 + " days remaining" : "Please increase the number of days or add the " + this.validationMessages.EMAILS_V2020_LOWER_TEXT_WITH_S + " in another Group";
          this.emailValueGroup1 = this.bypassAuthGroupInfo.group1Emails;
        }
        if (this.bypassAuthGroupInfo.group2Emails != undefined || this.bypassAuthGroupInfo.group2Emails !== '') {
          let remainingDaysGroup: number = this.numberofDaysRemainig(this.byPassValueGroup2);
          this.numberofDaysRemainingGroup2 = remainingDaysGroup > 0 ? +remainingDaysGroup + " days remaining" : "Please increase the number of days or add the " + this.validationMessages.EMAILS_V2020_LOWER_TEXT_WITH_S + " in another Group";
          this.emailValueGroup2 = this.bypassAuthGroupInfo.group2Emails;

        }
        if (this.bypassAuthGroupInfo.group3Emails != undefined || this.bypassAuthGroupInfo.group3Emails !== '') {
          let remainingDaysGroup: number = this.numberofDaysRemainig(this.byPassValueGroup3);
          this.numberofDaysRemainingGroup3 = remainingDaysGroup > 0 ? +remainingDaysGroup + " days remaining" : "Please increase the number of days or add the " + this.validationMessages.EMAILS_V2020_LOWER_TEXT_WITH_S + " in another Group";
          this.emailValueGroup3 = this.bypassAuthGroupInfo.group3Emails;
        }
        if (this.gracePeriodApplyToAllUsersCheck) {
                  const remainingDaysGroup: number = this.numberofDaysRemainig(
                    this.group4DaysValue
                  );
                  this.numberofDaysRemainingGroup4 =
                    remainingDaysGroup > 0
                      ? +remainingDaysGroup + ' days remaining'
                      : 'Please increase the number of days to allow grace period for all users';
                  this.group4DaysValue = this.bypassAuthGroupInfo.group4Days;
                }
        if (this.application.appletByPassDateTime > 0) {
          this.noOfDaysByPassAgentActivation = this.noOfDaysByPassAgentActivationFunction();
          this.startDateOfByPassAgentActivation = this.startDateOfByPassAgentActivationFunction();
        }
        else {
          this.noOfDaysByPassAgentActivation = "";
          this.startDateOfByPassAgentActivation = 0;
        }

        if (this.application.thirdPartyServicesActivated != undefined && this.application.thirdPartyServicesActivated != null &&
          this.application.thirdPartyServicesActivated != "") {
          if (this.application.thirdPartyServicesActivated.indexOf("Phishing") >= 0) {
            this.enablePhishing = true;
          }
          else {
            this.enablePhishing = false;
          }
          if (this.application.thirdPartyServicesActivated.indexOf("SAT") >= 0) {
            this.enableSAT = true;
          }
          else {
            this.enableSAT = false;
          }
        }
        else {
          if (!this.enablePhishing && !this.enableSAT) {
            this.application.thirdPartyServicesActivated = null;
          }
        }

      }
    } catch (err) {

    }

  }

  keyPressNumbers(event) {
        this.isGroup4Edited = true;
        var charCode = (event.which) ? event.which : event.keyCode;
        // Only Numbers 0-9
        if ((charCode < 48 || charCode > 57)) {
          event.preventDefault();
          return false;
        } else {
          return true;
        }
   }

  startDateOfByPassAgentActivationFunction(): string {
    let appletByPassDateTimeDateObj = new Date(this.application.appletByPassDateTime);
    let dateTime = "Date: " + (appletByPassDateTimeDateObj.getMonth() + 1) + '/' + appletByPassDateTimeDateObj.getDate() + '/' + appletByPassDateTimeDateObj.getFullYear() + " Time: " + appletByPassDateTimeDateObj.getHours() + ":" + appletByPassDateTimeDateObj.getMinutes() + ":" + appletByPassDateTimeDateObj.getSeconds();
    return dateTime;
  }
  noOfDaysByPassAgentActivationFunction(): number {
    let currentDate = new Date();
    let appletByPassDateTimeDateObj = new Date(this.application.appletByPassDateTime);
    let expirationDate = appletByPassDateTimeDateObj.setUTCDate(appletByPassDateTimeDateObj.getUTCDate());
    let timeDiff = currentDate.getTime() - expirationDate;
    return Math.ceil(timeDiff / (1000 * 3600 * 24));
  }

  getThirdPartyString(): void {
    if (this.application.thirdPartyServicesActivated !== null && this.application.thirdPartyServicesActivated !== ""
      && this.application.thirdPartyServicesActivated !== undefined) {
      if (this.application.thirdPartyServicesActivated.indexOf("Phishing") >= 0) {
        this.enablePhishing = true;
      }
      if (this.application.thirdPartyServicesActivated.indexOf("SAT") >= 0) {
        this.enableSAT = true;
      }
    }
  }

  toggleSatUI() {
    this.enableSAT = this.enableSAT ? false : true;
  }

  togglePhishingUI() {
    this.enablePhishing = this.enablePhishing ? false : true;
  }

}
